import * as React from 'react';
import dataBThree from './json/dataBThree';
import trustpilot from '../../../assets/img/trustpilot.png';
import { Link } from 'react-router-dom';
export interface IBodyThree {
  match: any;
}

export default function BodyThree(props: IBodyThree) {
  return (
    <>
      <div className='mt-10 flex h-56 flex-wrap  bg-BodyThree  justify-center lg:justify-between w-screen '></div>
      <div className='mt-10 text-center my-4  text-3xl font-medium flex justify-center flex-wrap'>
        <div className='mt-5 mr-2'>TESTIMONIALS BY</div>
        <div className=' '>
          <img src={trustpilot} alt='' className='h-20' />
        </div>
      </div>
      <div className='   grid grid-cols-1 lg:grid-cols-3  mx-3 justify-items-center'>
        {dataBThree.map((data, index) => {
          let removeFor = data.url.replace(/\//, '');

          return (
            <>
              <div
                key={index}
                className=' flex-col w-full mt-10   flex px-4 justify-items-center '
              >
                <div className='flex justify-center'>
                  <i className='fas fa-quote-left  text-fr text-4xl'></i>
                </div>
                <div className=' '>
                  <div className=' text-center py-3 text-2xl '>{data.name}</div>
                  <div className=' text-center  py-3 text-2xl '>
                    {data.title}
                  </div>
                  <div className=' text-center  py-3 text-2xl  '>
                    {data.body}
                  </div>
                  <a href={removeFor} className='flex justify-center mt-10'>
                    <div className=' text-center  py-3 text-2xl text-white bg-fr w-3/4  flex justify-center'>
                      Click to check the review
                    </div>
                  </a>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
}
